import type { ReceiptTemplate } from '../schema';

export const harborFreightTemplate: ReceiptTemplate = {
  id: 'harbor-freight',
  name: 'Harbor Freight Receipt',
  brand: 'HARBOR FREIGHT',
  description: 'Harbor Freight tools store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'hf-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/harbor-freight.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [
          'TOOLS',
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hf-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hf-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'PITTSBURGH WRENCH SET', quantity: '1', price: '29.99', sku: '847291034' },
          { id: '2', name: 'CHICAGO ELECTRIC DRILL', quantity: '1', price: '39.99', sku: '847291035' },
          { id: '3', name: 'WORK GLOVES 3PK', quantity: '1', price: '9.99', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hf-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '79.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '6.60', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '86.57', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hf-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hf-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'INSIDE TRACK MEMBER\n\nReturns within 90 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

